import React from 'react';

export const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function Svg({ className, children, size = 24, viewBox = '0 0 24 24' }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      width={size}
      height={size}
      aria-hidden="true"
      {...strokeProps}
    >
      {children}
    </svg>
  );
}
